import { Link } from "react-router-dom";

export default function SiteFooter() {
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-[color:var(--hairline)] mt-8"
      style={{ background: "var(--bg-1)" }}
    >
      <div className="container-page py-14 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-12">
          <div className="md:col-span-5">
            <div className="eyebrow">Bishop Creative</div>
            <p className="mt-4 font-display text-2xl md:text-3xl leading-[1.15] text-[color:var(--text-1)] max-w-[24ch]">
              Local roots. Lasting impressions.
            </p>
            <p className="mt-5 text-sm text-[color:var(--text-3)] max-w-[42ch]">
              A student-run studio crafting websites, hosting, and social
              media for the Central Coast’s most considered brands.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="eyebrow">Studio</div>
            <ul className="mt-4 space-y-3 text-sm">
              <li>
                <Link to="/services" className="text-[color:var(--text-2)] hover:text-[color:var(--text-1)]">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-[color:var(--text-2)] hover:text-[color:var(--text-1)]">
                  About
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  data-testid="footer-contact-link"
                  className="text-[color:var(--text-2)] hover:text-[color:var(--text-1)]"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="eyebrow">Correspondence</div>
            <ul className="mt-4 space-y-3 text-sm text-[color:var(--text-2)]">
              <li>hello@bishopcreative.co</li>
              <li>
                San Luis Obispo, California
                <span className="block text-[color:var(--text-3)] text-xs mt-1">
                  Serving Paso Robles, Santa Barbara & the Central Coast
                </span>
              </li>
              <li className="text-[color:var(--text-3)] text-xs mt-2">
                Mon – Fri · 9:00 – 17:00 PT
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 md:mt-20 pt-6 border-t border-[color:var(--hairline)] flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="eyebrow">
            © {new Date().getFullYear()} Bishop Creative — Central Coast Studio
          </div>
          <div className="eyebrow text-[color:var(--text-3)]">
            Made with intention in San Luis Obispo
          </div>
        </div>
      </div>
    </footer>
  );
}
